export const urlToScopeKey = (urlString: string) => {
  const url = new URL(urlString);
  const host = url.origin;
  const rootPath = url.pathname.split('/')[1] || '';
  return `${host}/${rootPath}`
}